// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3BPf7","noInteraction":"EventWrapper_noInteraction__1-4HZ","pointerPassthrough":"EventWrapper_pointerPassthrough__37jkj"};